module.exports = __webpack_public_path__ + "img/CS-Profi13-Profiles.69aff1db.jpg";